
const useAccessToken = () => {
    return localStorage.getItem("access_token");
}


export { useAccessToken }